import React, { Suspense, useEffect, useMemo, useState } from "react";
import { inject, observer } from "mobx-react";
import { withResizeDetector } from "react-resize-detector";
import { useTranslation } from "react-i18next";
import LanguageSelection from "./partials/Header/parts/languageSelection";

interface IWithoutLayout {
  exact: boolean;
  computedMatch: any;
  component: any;
  title: string;
  UIStore?: any;
  width: number;
  height: number;
  targetRef?: any;
  routes?: any;
}

const WithoutLayout = inject("UIStore")(
  observer(
    withResizeDetector((props: IWithoutLayout) => {
      const { exact, component: Component, title, ...rest } = props;
      const { t } = useTranslation();

      const MemoizedComponent = useMemo(() => <Component {...rest} />, []);
      const styles = {
        container: {
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          height: "100vh",
          textAlign: "center",
        },
        text: {
          marginBottom: "20px",
          fontSize: "20px",
          fontWeight: "bold",
        },
        boxContainer: {
          display: "flex",
          gap: "10px",
          justifyContent: "center",
        },
        box: {
          width: "10px",
          height: "10px",
          borderRadius: "50%",
          transition: "background-color 0.5s ease",
          border: "1px solid #000",
          backgroundColor: "transparent",
        },
      };
      const [filledBoxes, setFilledBoxes] = useState(0);

      useEffect(() => {
        let timer: string | number | NodeJS.Timeout | undefined;
        if (filledBoxes < 3) {
          timer = setTimeout(() => {
            setFilledBoxes((prev) => prev + 1);
          }, 1000);
        } else if (filledBoxes === 3) {
          timer = setTimeout(() => {
            setFilledBoxes(0);
          }, 1000);
        }

        return () => clearTimeout(timer);
      }, [filledBoxes]);

      return (
        <div className="main-container">
          <div className="top-right-corner">
            {/* Beyaz bir div içine LanguageSelection ve animasyonu ekle */}
            <div className="container-fluid language-selection-container d-flex align-items-center justify-content-center">
              <LanguageSelection />
            </div>

            <div className="container-fluid">
              <div className="navbar-brand d-flex align-items-center">
                <div style={styles.boxContainer}>
                  {[0, 1, 2].map((index) => (
                    <div
                      key={index}
                      style={{
                        ...styles.box,
                        backgroundColor:
                          index < filledBoxes ? "red" : "transparent",
                        border: index < filledBoxes ? "none" : "1px solid #000",
                        transition: "background-color 1s ease-in-out",
                      }}
                    ></div>
                  ))}
                </div>
              </div>
            </div>
          </div>
          {MemoizedComponent}
        </div>
      );
    })
  )
);

export default WithoutLayout;
